import { Text } from "@clipboard-health/ui-components";
import { formatDollarsAsUsd } from "@src/appV2/lib/Money/utils/currency";

import { type PaymentsListItem } from "../types/PaymentsListItem";

export interface PaymentsListItemAmountProps {
  item: PaymentsListItem;
}

export function PaymentsListItemAmount(props: PaymentsListItemAmountProps) {
  return (
    <Text semibold variant="body1">
      {formatDollarsAsUsd(props.item.attributes.amountInCents / 100)}
    </Text>
  );
}
